// npm i serve -D
// npx serve -s build
import React, {useState, useEffect, Component, createContext, useContext, useMemo, Suspense} from 'react'
import ReactDOM from 'react-dom/client'
import axios from 'axios'
import { Link as RouterLink, useLoaderData,createBrowserRouter, createRoutesFromElements, Navigate, Await, BrowserRouter, Route, Routes, NavLink, useNavigate, useLocation, useOutlet, useParams} from 'react-router-dom'
import {loadStripe} from '@stripe/stripe-js'
import { HiMiniSlash } from 'react-icons/hi2'
import { MdKeyboardArrowRight,MdEdit } from 'react-icons/md'
import { IoMdClose,IoIosLogOut } from 'react-icons/io'
import { CiMenuBurger } from 'react-icons/ci'
import './scss/style.css'
import list1 from './util/pagelist.js'
import {UserInfoPage} from './pages/AccountPage.js'
import {PurchasedHistoryPage} from './pages/PurchasedHistory.js'
import {PaymentPage, PaymentDonePage} from './pages/PaymentPage.js'
import {PurchasedCodePage} from './pages/PurchasedCodePage.js'
import {PrivacyPolicyPage} from './pages/PrivacyPolicyPage.js'
import AccountMembershipPage1 from './pages/AccountMembershipPage1.js'
import AccountMembershipPage2 from './pages/AccountMembershipPage2.js'
import SignUpPage from './pages/SignUpPage.js'
import {VerifyAccountPage1,VerifyAccountPage2} from './pages/VerifyAccountPage.js'
import {VerifyUpdatedEmailPage1,VerifyUpdatedEmailPage2} from './pages/VerifyUpdatedEmailPage.js'
import LoginPage from './pages/LoginPage.js'
import ReactBasicPage from './components/bGDVPLhqfPDEMZUi/ReactBasicPage'
import ResetPwdPage from './pages/ResetPwdPage.js'
import {MainPage1, MainPage2} from './pages/MainPage.js'
import APIPage from './pages/APIPage.js'
import NSDQPage from './components/API/nsdq'
import NYSEPage from './components/API/nyse'
import NSDQ100Page from './components/API/nsdq100.js'
import NYSE100Page from './components/API/nyse100.js'
import SandP500Page from './components/API/s&p500.js'
import DowJones30Page from './components/API/dowjones30.js'
import Russel2000Page from './components/API/russel2000.js'
import GoldPage from './components/API/gold.js'
import OilPage from './components/API/oil.js'
import ReactPage1 from './pages/ReactPage1.js'
import ReactPage2 from './pages/ReactPage3.js'
import PythonPage1 from './pages/PythonPage1.js'
import PythonPage2 from './pages/PythonPage2.js'
import AssetManagementPage from './components/finance/1.js'
import StockNotifyPage from './components/finance/StockNotify.js'
import StockPortfolioPage from './components/finance/StockPortfolio.js'
import StockBuySellPage from './components/finance/StockBuySell.js'
import CodeofConductPage from './pages/CodeofConductPage.js'
import ContactUsPage from './pages/ContactUsPage.js'
import TermsandConditionAgreementsPage from './pages/TermsandConditionAgreements.js'
import ErrorPage from './pages/404Page.js'
import { IoIosArrowDown,IoIosArrowForward,IoIosCheckmark,IoIosHeart } from 'react-icons/io'
import { GiShoppingCart } from 'react-icons/gi'
import Settings from '@mui/icons-material/Settings'
import LinearProgress from '@mui/material/LinearProgress'
import Alert from '@mui/material/Alert'
import Avatar from '@mui/material/Avatar'
import TextField from '@mui/material/TextField'
import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Button from '@mui/material/Button'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import MenuItem from '@mui/material/MenuItem'
import AIPage from './components/python/AIPage.js'
import BackendBasicPage from './components/python/BasicPage'
import ShoppintItemsJS from './components/bGDVPLhqfPDEMZUi/ShoppingItems.js'
// import LoginSimpleJS from './components/react/LoginSimple'
// import LoginVerifyByEmailJS from './components/LoginVerifyByEmail'

import LlmABConversations from './components/python/LlmABConversations.js'
import LlmAuthor from './components/python/LlmAuthor.js'
import LlmSpeechText from './components/python/LlmSpeechText.js'
import LlmTranslator from './components/python/LlmTranslator.js'
import LlmGenerateImg from './components/python/GenAIImg.js'
import LlmContext from './components/python/LlmContext.js'
import LlmCopilot from './components/python/LlmCopilot.js'
import LlmSummarize from './components/python/LlmSummarize.js'
import LlmStockNews from './components/python/LlmStockNews.js'
import LlmRag1 from './components/python/LlmRag1.js'
import LlmRag2 from './components/python/LlmRag2.js'
import LlmBrowerSearch from './components/python/LlmGoogleSearch.js'
import LoginDifferentPagesJS, {App2, router} from './components/bGDVPLhqfPDEMZUi/LoginDifferentPages.js'
import PaymentJS from './components/bGDVPLhqfPDEMZUi/Payment.js'
import TmpEncryptJS from './components/bGDVPLhqfPDEMZUi/TmpEncrypt.js'
import PaginationJS from './components/bGDVPLhqfPDEMZUi/Pagination.js'
// import Fog from './images/fog.png'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
const options = {
     mode:'payment',
     amount: 0.50,
     currrency:'usd',
     appearance:{}
}
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
function AfterPurchase(){
     //   const [status, setStatus] = useState(null)
     //   const [customerEmail, setCustomerEmail] = useState('')
     // useEffect(() => {
     //   const queryString = window.location.search
     //   const urlParams = new URLSearchParams(queryString)
     //   const sessionId = urlParams.get('session_id')
   
     //   fetch(`/session-status?session_id=${sessionId}`)
     //     .then((res) => res.json())
     //     .then((data) => {
     //       setStatus(data.status)
     //       setCustomerEmail(data.customer_email)
     //     })
     // }, [])
     // if (status === 'open') {
     //   return (
     //     <Navigate to='/pay' />
     //   )
     // }
     // if (status === 'complete') {
     //   return (
     //     <section id='success'>
     //       <p>
     //         We appreciate your business! A confirmation email will be sent to {customerEmail}.
   
     //         If you have any questions, please email <a href='mailto:orders@example.com'>orders@example.com</a>.
     //       </p>
     //     </section>
     //   )
     // }
   
   //   return null
     return (
       <>
       Purchase successfully finihsed!<br/>
       <Link to={'/'}>Back</Link>
       </>
     )
}
export const HeaderNav = ({ pages }) => {
     const [loginCheck, setLoginCheck] = useState(false)
     const [myAccountMenu, setMyAccountMenu] = useState(false)
     const [cartMenu, setCartMenu] = useState(false)
     const [sideNavMenu, setSideNavMenu] = useState(false)
     const [stickyNav, setStickyNav] = useState(false)
     const [shoppingCart3, setShoppingCart3] = useState([])
     const { shoppingCart1, shoppingCart2, user2, auth2FA1, auth2FA2, autoLogin, logout } = useAuth()
     const PcDislay = window.innerWidth
     useEffect(() => {
          if(!loginCheck){
               const x = window.localStorage.getItem('token')
               if (x) {tokenCheck(x)}
          }
          setShoppingCart3(shoppingCart2)
     },[shoppingCart2])
     const tokenCheck = async(x) => {
          try {
               const { data: res } = await axios.post(`${APIURL}/auto-login`, {'token':x})
               if (res.msg==='You are auto logined.'){
                    if(res.user.firstname!='' && res.user.lastname!=''){
                         await autoLogin({'username':res.user.username,'url':`https://ui-avatars.com/api/?name=${res.user.firstname[0]}+${res.user.lastname[0]}&background=000&color=fff`,'unlocked_code':res.user.unlocked_code})
                    }else{
                         await autoLogin({'username':res.user.username,'url':`https://ui-avatars.com/api/?name=${res.user.email[0]}&background=000&color=fff`,'unlocked_code':res.user.unlocked_code})
                    }
                 }else{
                    logout()
                 }
          } catch (e) {console.log(e)}
          setLoginCheck(true)
     }
     const TotalPrice=()=>{
          let total=0
          shoppingCart3.map((x)=>total += x.price * x.unit)
          return total
     }
     const onClick2OpenCartMenu=()=>{
          if (shoppingCart3!=[]) {
               setShoppingCart3(shoppingCart2)
          }
          setCartMenu(!cartMenu)
     }
     const onClick2RemoveItem=(x1)=>{
          if(shoppingCart3.length==1){
               setShoppingCart3([])
               shoppingCart1([])
          }else{
               const x2 =shoppingCart2.filter((x)=>x.id!==x1.id)
               setShoppingCart3(x2)
               shoppingCart1(x2)
          }
     }
     const onClick2SideNav=()=>{
     if(!sideNavMenu){
          console.log('menu clicked open')
          document.querySelector('.structure__sidenav').classList.remove('hidden')
          document.querySelector('.structure__sidenav').classList.add('absolute')
          document.querySelector('.structure__sidenav').classList.add('sticky')
           document.querySelector('.structure__sidenav').classList.add('top-[0px]')
          document.querySelector('.structure__sidenav').classList.add('z-[2]')
     }else{
          console.log('menu clicked close')
          document.querySelector('.structure__sidenav').classList.add('hidden')
          document.querySelector('.structure__sidenav').classList.remove('sticky')
          document.querySelector('.structure__sidenav').classList.remove('top-[0px]')
          document.querySelector('.structure__sidenav').classList.remove('absolute')
          document.querySelector('.structure__sidenav').classList.remove('z-[2]')
     }
        setSideNavMenu(!sideNavMenu)
     }
     function sp_nav_property(){
          //find out where y-axis is at
          let prevY = window.scrollY;
          window.addEventListener('scroll', () => {
          const currY = window.scrollY;
          if (currY < prevY|| window.scrollY<10)  {
               setStickyNav(false)
          } else {
               setStickyNav(true)
          }
               prevY = currY;
          })
     }
     sp_nav_property()
     const a = useLocation()
     return (
          <div id='sp_nav' className='structure__headernav'>
          <div className='structure__headernav__L'>
          <RouterLink className={`structure__headernav__ttl ${stickyNav?'hidden md:inline':''}`} to='/'>Dev Cookbooks</RouterLink>
          {a.pathname=='/main'||a.pathname=='/'?<CiMenuBurger className={`${stickyNav?'mt-[6px]':'mt-[-2px]'} pl-[4px] inline md:hidden`}
          onClick={onClick2SideNav}/>:<><CiMenuBurger className={`mt-[9px] pl-[4px] md:hidden ${stickyNav?'inherit ':'hidden'}`} onClick={onClick2SideNav}/></>}
          <RouterLink className='structure__headernav__item1 hidden md:inline' to='/react'>React</RouterLink>
          <RouterLink className='structure__headernav__item1 hidden md:inline' to='/python'>Python</RouterLink>
          <RouterLink className='structure__headernav__item1 hidden md:inline text-[8px]' to='/membership-price-list'>Membership</RouterLink>
          {/* <RouterLink className='structure__headernav__item hidden md:inline' to='/node'>Node</RouterLink> */}
          {/* <RouterLink className='structure__headernav__item hidden md:inline' to='/community'>Community</RouterLink> */}
          </div>
          <div className='structure__headernav__L'>
          </div>
          <div className='structure__headernav__R'>
          {user2 && auth2FA2 ?<>
          <div className='structure__headernav__menu__wrapper'>
          <button className='flex' onClick={()=>setMyAccountMenu(!myAccountMenu)}><img src={user2.url} className='structure__headernav__avatar' style={{border:myAccountMenu?'2px rgba(135, 166, 228, 0.89) solid':''}}/>
          <p className='m-auto hidden md:inline'>Hi, {user2.username}</p></button>
          <button className='structure__headernav__cart'  onClick={onClick2OpenCartMenu}><GiShoppingCart/></button>
          </div>
               {myAccountMenu?<div className='structure__headernav__menu' onClick={()=>setMyAccountMenu(!myAccountMenu)}>
               <RouterLink className='structure__headernav__menu__item' to='/myaccount'>User Information</RouterLink>
               <RouterLink className='structure__headernav__menu__item' to='/myaccount/orders'>Your Orders</RouterLink>
               <RouterLink className='structure__headernav__menu__item' to='/myaccount/account-membership'>Account Membership Status</RouterLink>
               {/* Billing */}
               {/* <RouterLink className='structure__headernav__menu__item' to='/myaccount/purchased-code'>Puchased Code</RouterLink> */}
               {/* <RouterLink className='structure__headernav__menu__item' to='/myaccount/account-membership'>Change Membership</RouterLink> */}
               <RouterLink className='structure__headernav__menu__item' onClick={logout}>Logout</RouterLink>
               </div>:''}
               {cartMenu?<div className='structure__cart__menu p-2'>
               <div className='flex justify-between bitter'><div>Cart</div><IoMdClose onClick={()=>setCartMenu(!cartMenu)}/></div>
               {shoppingCart3.length!=0?<>{shoppingCart3.map((x)=>(
               <div className='structure__cart__container'>
               <div className='flex justify-between'>
               <div className='mt-[0px]'><img className='w-[42px] mr-1' src={x.img} alt='cart-item'/></div>
               <div className='w-full flex flex-col ml-[2px]'>
               <div className='flex text-[8px]'>
               <b>{x.product_name}</b><br/>
               <div className='ml-auto'><IoMdClose onClick={()=>onClick2RemoveItem(x)}/></div>
               </div>
               <div className='w-full flex justify-between text-[8px]'>
               <div className='ml-[30px] text-right leading-[1em] text-[8px] mt-auto'>
               {x.price}<br/>
               <span className='text-[6px]'>(Tax 8.25%)</span><span className='text-[6px] ml-[8px]'>{(x.price*0.0825).toFixed(2)}</span>
               </div>
               <div className='mt-auto text-[8px]'>{(x.price*1.0825).toFixed(2)}</div>
               </div>
               </div>
               {/* <div className='w-full flex text-[8px]'>
               
               </div> */}
               </div>
               </div>
               ))}
               <div className='text-right text-[9px] border-t border-gray-800 mb-[18px]'>Total US${((shoppingCart3.map((x1)=>x1.price*x1.unit)).reduce((x2,y2)=>x2+y2,0)*1.0825).toFixed(2)}</div>
               <RouterLink className='bitter bg-[#414c75] hover:bg-[#365c88] w-[130px] h-[24px] text-white text-[9px]  m-auto flex' to='/myaccount/payment' onClick={()=>setCartMenu(!cartMenu)}><div className='m-auto w-fit'>Proceed to checkout</div></RouterLink></>:'No item is added.'}</div>:''}
              </>:<>
               {pages?.map((page) => (
               <RouterLink className={`structure__headernav__account bitter mt-[0px] ${page.label=='Login'?'bg-[#414c75] hover:bg-[#365c88] hover:underline':'bg-[#B5B5B5] hover:bg-[#b5b5b58f] hover:underline'}{`} to={page.path}>{page.label}</RouterLink>))}</>}
               {/* account login signup user */}      
          </div>
          </div>
     )
} 
export const RedirectLv1 = () => {
     let params = useParams()
     const navigate = useNavigate()
     const lv1= ['community','myaccount','payment','account-membership','purchased-code','after-purchase','payment-success','login','reset-pwd','signup','verify-account','verify-email','404','code-of-conduct','terms-and-conditions','privacy-policy','contact-us','main','react','python']
     useEffect(()=>{
          if(lv1.includes(params.lv1)){
               navigate(`/${params.lv1}`)
          }else{
               navigate('/404')
          }
     })
     return (
          <>RedirectLv1</>
     )
}
export const RedirectLv2 = () => {
     let params = useParams()
     const navigate = useNavigate()
      const lv1= ['community','myaccount','payment','account-membership','purchased-code','after-purchase','payment-success','login','reset-pwd','signup','verify-account','verify-email','404','code-of-conduct','terms-and-conditions','privacy-policy','contact-us','main','react','python']
     useEffect(()=>{
          if(lv1.includes(params.lv1)){
               navigate(`/${params.lv1}/${params.lv2}`)
          }else{
               navigate('/404')
          }
     })
     return (
          <>RedirectLv2</>
     )
}
export const TestAbout = () => {
     return (
          <>about page<br/>
          <RouterLink to='/'>• Main</RouterLink>
          </>
     )
}
export const MainLayout = () => {
     const { user2 } = useAuth()
     const outlet = useOutlet()
     let params = useParams()
     return (
       <>
          <HeaderNav
           pages={[
             { label: 'Login', path: '/login' },
             { label: 'Sign Up', path: '/signup' }
           ]}
          />
          <Breadcrumbs/>
          <div className='structure__main__wrapper md:flex'>
          <SideNav/>
          {outlet}
          </div>
       </>
     )
}
export const ProtectedLayout = ({ content2, path2 = () => { } }) => {
     const { user2 } = useAuth()
     const page1 = useOutlet()
     if (!user2) {
          return <Navigate to='/login' />
     }
     return( 
          <div id='llm-chatbot' className='llm-chatbot-page'>
          <HeaderNav pages={[
             { label: 'Login', path: '/login' },
             { label: 'Sign Up', path: '/signup' }
           ]}/>
          <Breadcrumbs/>
          <div className='structure__main__wrapper md:flex'>
          <SideNav content1={content2} path1={path2} />
          <div className='structure__main'>
          {page1}
          </div>
          </div>
          </div>
     )
}
export function Breadcrumbs() {
     const location = useLocation()
     let currentLink =''
     let breadcrumbs = location.pathname.split('/').filter(x => x!== '')
     breadcrumbs = breadcrumbs.map((x,i)=>{
       currentLink+= `/${x}`
       if(i==breadcrumbs.length-1){
         return(<div className='flex' key={x}><RouterLink className='hover:underline hover:font-bold mt-auto mb-auto cursor-default' to={currentLink}>{x}</RouterLink></div>)
       }else{
         return(<div className='flex' key={x}><RouterLink className='hover:underline hover:font-bold mt-auto mb-auto cursor-default' to={currentLink}>{x}</RouterLink><HiMiniSlash/></div>)
       }
     })
     return(
       <div className='structure__breadcrumb'>
       {location.pathname=='/'?<RouterLink className='hover:underline hover:font-bold mt-auto mb-auto cursor-default' to='/'>Home</RouterLink>:<div className='flex'><RouterLink className='hover:underline hover:font-bold mt-auto mb-auto cursor-default' to='/'>Home</RouterLink><HiMiniSlash/>{breadcrumbs}</div>}
       </div>
     )
}
export function FooterNav(){
     return(
          <>
          <div className='structure__footernav'>
          <div className='structure__footernav__container'>
               <div className='structure__footernav__sublink1'>
               <RouterLink className='structure__footernav__ttl' to='/privacy-policy'>Privacy Policy</RouterLink>
               {/* <RouterLink className='structure__footernav__ttl' to='/code-of-conduct'>Code of Conduct</RouterLink> */}
               <RouterLink className='structure__footernav__ttl' to='/terms-and-conditions'>Terms & Conditions</RouterLink>
               </div>
               <div className='structure__footernav__sublink2'>
               <RouterLink className='structure__footernav__ttl' to='contact-us'>Contact Us</RouterLink>
               </div>
          </div>
          <p className='flex'>Made with <IoIosHeart/> by Dev Cookbooks</p>
          </div>
          </>
     )
}
export function SideNav({ content1, path1 = () => { } }){
     let list2=(list1.find(x=> x.label=='React').lv3).concat(list1.find(x=> x.label=='Python').lv3).concat(list1.find(x=>x.label=='API').lv3).concat(list1.find(x=>x.label=='Finance App').lv3)
     const [display,setDisplay]=useState(['React','Python CPP Java NodeJS','API','Finance App'])//'API','Deploy','Util API','React','Python NodeJS C++'     
     const onClick2ChangeMainPage=(x)=>{
         console.log('jump to main page path',x)
         if(display.includes(x)){
          setDisplay(display.filter((y) => y != x))
          }else{
               setDisplay([...display,x])
          }
          document.querySelector('.structure__sidenav').classList.add('hidden')
     }
     const onClick2ChangeSubPage=(x)=>{
         content1(x.page)
         path1(x.path)
         document.querySelector('.structure__sidenav').classList.add('hidden')
     }
     const onClick2Display=(x)=>{
          if(display.includes(x)){
               //remove
               setDisplay(display.filter((y) => y != x))
          }else{
               //add
               setDisplay([...display,x])
          }
     } 
     const onClick2Close=()=>{
          document.querySelector('.structure__sidenav').classList.add('hidden')
          document.querySelector('.structure__sidenav').classList.remove('absolute')
          document.querySelector('.structure__sidenav').classList.remove('z-[2]')
     }
     return(
          <div className={`structure__sidenav flex justify-between hidden w-full md:inline md:w-[140px]`}>
          <div className='flex flex-col text-lg md:text-xs cursor-default'>
          {list2.map(x1=><><div className='mt-1 mb-1 font-bold flex' onClick={()=>onClick2Display(x1.label)}>{x1.label}<>{display.includes(x1.label)?<IoIosArrowDown className='mt-auto mb-auto'/>:<IoIosArrowForward className='mt-auto mb-auto'/>}</>
          </div> 
          {x1.lv4.map(x2=><>{display.includes(x1.label)?<div onClick={onClick2Close}><RouterLink to={x2.path} className={`${x2.path=='/'+document.URL.split('/').slice(3,5).join('/')?'font-bold':''} hover:text-gray-500`}>•{x2.label}</RouterLink></div>:''}</>)}
          </>)}
          </div>         
          <div className='inline md:hidden mr-4' onClick={onClick2Close}><IoMdClose className='mt-[8px]'/></div>
          </div>
     )
          {/* <div className='flex flex-col text-lg md:text-xs cursor-default'>
          {list2.map((x,i)=>{
               if(display.includes(x.label)){
               return <>
               <div className='mt-1 mb-1 font-bold flex' onClick={()=>onClick2Display(x.label)}>{x.label} <IoIosArrowDown className='mt-auto mb-auto'/></div> 

               {(x.lv4).map((y,i)=>{
               if(y.lv5){
                    return <RouterLink className='hover:underline hover:font-bold' 
                    onClick={()=>onClick2ChangeSubPage(y)}
                    to={y.path}
                    ><div className='ml-2 '>•{y.label}</div> {
                    (y.lv5).map((z,i)=><div className='ml-4 md:text-[9px] text-gray-500'>{z.label}</div>)
                    }</RouterLink>
               }else{
                    return <RouterLink className='hover:underline hover:font-bold' 
                    onClick={()=>onClick2ChangeSubPage(y)}
                    to={y.path}
                    ><div className='ml-2'>•{y.label}</div></RouterLink>
               }
          }
          )}
          </>
          }else if(x.lv4){
               return <div className='mt-1 mb-1 flex hover:font-bold' onClick={()=>onClick2Display(x.label)}
               >{x.label}<IoIosArrowForward className='mt-auto mb-auto'/></div>
          }else{
               return <RouterLink className='mb-1 hover:underline hover:font-bold' 
               onClick={()=>onClick2Display(x.label)}
               to={x.path}
               >{x.label}</RouterLink>
          }
          })}</div> */}
}
export const ProtectedLayout_APIPageLayout = () => {
     const { user2, auth2FA2 } = useAuth()
     const page1 = useOutlet()
     if (!user2) {
          return <Navigate to='/login' />
     }
     else if(!auth2FA2) {
        return <Navigate to='/2fa' />
     } 
     return( 
          <>
          <HeaderNav/>
          <Breadcrumbs/>
          <div className='structure__main__wrapper md:flex'>
          <div className='structure__main'>
          {page1}
          </div>
          </div>
          </>
     )
}
export const Page = ({content5,path5}) => {
     return (<>{content5}</>)
}
export const Page2 = ({content5,path5}) => {
     return (<>{content5}</>)
}
export const Shopping = () => {
     return (<>Shopping Page</>)
}
export const Crud = () => {
     return (<>Crud Page</>)
}
export const Display = () => {
     return (<>Display Page</>)
}
export const Llm = () => {
     return (<>LLM Page</>)
}
export const LlmTool = () => {
     return (
          <div className='m-4'>
          <h2 className='mb-4 text-lg structure__main__ttl'>Llm Tools</h2>
          <p className='text-sm mb-12'>Llm tools help to provide accurate and orginal answer by adding extra data.<br/> 
          Also, LLM can be only generated from backend.
          </p>
          </div>
     )
}
export const Notification = () => {
     return (<>Notification Page</>)
}
export const useLocalStorage = (x1, y1) => {
     const [item, setItem] = useState(() => {
       try {
         const x2 = window.localStorage.getItem(x1)
         if (x2) {
           return JSON.parse(x2)
         } else {
           window.localStorage.setItem(x1, JSON.stringify(y1))
           return y1
         }
       } catch (err) {
         return y1
       }
     })
     const updatedItem = (y2) => {
       try {
         window.localStorage.setItem(x1, JSON.stringify(y2))
       } catch (err) {
         console.log(err)
       }
       setItem(y2)
     }
     return [item, updatedItem]
 }
const AuthContext = createContext()
export const AuthProvider = ({children}) => {
   const [shoppingCart2, setShoppingCart2] = useLocalStorage('shopping-cart', [])
   const [user2, setUser2] = useLocalStorage('user', null)
   const [auth2FA2, setAuth2FA2] = useState(null)
   const navigate = useNavigate()
   const shoppingCart1 = async (x) => {
     if (x==[]){
          window.localStorage.removeItem('shopping-cart')
     }else{
          setShoppingCart2(x)
     }
   }  
   const login = async (x) => {
     setUser2(x)
     navigate('/main')
   }  
   const autoLogin = async (data) => {
     setUser2(data)
     setAuth2FA2('true')
   }  
   const auth2FA1 = async (x) => {
     setAuth2FA2('true')
     navigate('/react', { replace: true })
   }
   const logout = () => {
     setUser2(null)
     setAuth2FA2(null)
     localStorage.removeItem('token')
     localStorage.removeItem('user')
      window.location.replace(window.location.origin);
   }
   const value = useMemo(
     () => ({
       shoppingCart2,
       user2,
       auth2FA2,
       shoppingCart1,
       login,
       autoLogin,
       logout,
       auth2FA1,
     }),
     [shoppingCart2, user2, auth2FA2]
   )
   return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
export const useAuth = () => {return useContext(AuthContext)} 
const getUserData = () =>
   new Promise((resolve) =>
     setTimeout(() => {
       const user = window.localStorage.getItem('user')
       resolve(user)
     }, 3000)
)
export const AuthLayout = () => {
     const outlet = useOutlet()
     const { userPromise } = useLoaderData()
     return (
       <Suspense fallback={<LinearProgress />}>
         <Await
           resolve={userPromise}
           errorElement={<Alert severity="error">Something went wrong!</Alert>}
           children={(user) => (
             <AuthProvider userData={user}>Authed Layout {outlet}</AuthProvider>
           )}
         />
       </Suspense>
     )
}
export const BasicPage = ({ title, icon }) => {
     return (
       <Container component='main' maxWidth='xs'>
         <Box
           sx={{
             marginTop: 8,
             display: 'flex',
             flexDirection: 'column',
             alignItems: 'center',
             marginBottom:200
           }}
         >
           <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>{icon}</Avatar>
           <Typography component='h1' variant='h5'>
             {title}
           </Typography>
         </Box>
       </Container>
     )
}
export const TwoFAPage = () => {
     const {auth2FA1} = useAuth()
     const [code, setCode] = useState('')
     const onSubmit22FA = async (e) => {
       e.preventDefault()
       if (code === '1') {
         await auth2FA1({ code })
       } else {
         alert('Invalid code. Please try again.')
       }
     }
     return (
       <form onSubmit={onSubmit22FA}>
         <input
           type= 'text'
           value={code}
           onChange={(e) => setCode(e.target.value)}
           placeholder= 'Enter verification code'
         />
         <button type='submit'>Verify</button>
       </form>
     )
}
export const SettingPage = () => {
     return <BasicPage title='Settings page' icon={<Settings/>}/>
}
export function Login() {
   const [editMode, setEditMode] = useState(false)
   const [updateItem, setUpdateItem] = useState()
   const [list1, setList1] = useState([
     {
       id: '1',
       email: '1@gmail.com',
       password: '1',
       // username:'Don Joe1',
       // phonenumber:'',
       // role: 'admin',
     },
     {
       id: '2',
       email: '2@gmail.com',
       password: '2',
       // username:'Don Joe2',
       // phonenumber:'',
       // role: 'user',
     }
   ])
   const [email, setEmail] = useState()
   const [password, setPassword] = useState()
   //user useState
   const [loginInput, setLoginInput] = useState({})
   const [loginErr, setLoginErr] = useState(null)
   const [login, setLogin] = useState(false) 
   const [signup, setSignup] = useState(false)
   const [updateList, setUpdateList] = useState()
   const pages = [
     {},
     {}
   ]
 //   const routes = useRoutes([
 //     {
 //       path: "/",
 //       element: <HomePage />
 //     }
 //     // {
 //     //   path: "/login",
 //     //   element: <LoginPage />
 //     // },
 //     // {
 //     //   path: "/myaccount",
 //     //   element: <UserInfoPage />
 //     // }
 //   ])
   //user
   const onChange2Input1 = ({ currentTarget: x }) => { setLoginInput({ ...loginInput, [x.name]: x.value }) }
   const onClick2Create = () => {
     setLoginErr(null)
     let findEmail = list1.find((x) => x.email ==loginInput.email)
     console.log(findEmail==undefined)
     if(findEmail==undefined){
        //add loginInput.email ,loginInput.password to list1
        //setList1(updateList)
        setList1((x) => [
          ...x,
          {
            id: Math.random().toString(),
            email:loginInput.email,
            password:loginInput.password
            // role
          },
        ])
        setSignup(!signup)
        setLogin(!login)
 
        //   if(findEmail.password ==loginInput.password){
        //     console.log('login succeeded')
        //     setLogin(!login)
        //   }else{
        //     setLoginErr('Your password is not matched.')
        //   } 
       }else{
         setLoginErr('Your email is already in use. Please use another email.')
       }
   }
   const onClick2Login = () => {
     setLoginErr(null)
     let findEmail = list1.find((x) => x.email ==loginInput.email)
     if(findEmail!='undefined'){
       if(findEmail.password ==loginInput.password){
         setLogin(!login)
       }else{
         setLoginErr('Your password is not matched.')
       }
     }else{
       setLoginErr('Your email is not found.')
     }
   }
   //admin
   const onClick2delete = (dataId) => {
     setList1((x) => {
       return x.filter((x) => x.id !== dataId)
     })
   }
   const onClick2Edit = () => {
     setUpdateList(list1)
     setEditMode(!editMode)
   }
   const onSubmit2Update = (data1) => {
     setList1(updateList)
     setEditMode(!editMode)
   } 
   const onChange2Input2 = ({currentTarget:y}, x) => {
     var b1 = [...updateList]
     var b2 = updateList.filter((w) => w.id === x)[0]
     var i = updateList.indexOf(b2)
     setUpdateItem({...b2, [y.name]:y.value})
     b1[i] = {...b2, [y.name]:y.value}
     list3(b1)
   }
   const list3 = (list2) => {
     setUpdateList(list2)
     window.localStorage.setItem('list2', JSON.stringify(list2))
   }
   const onClick2Add = (e) => {
     e.preventDefault()
     setList1((x) => [
       ...x,
       {
         id: Math.random().toString(),
         email,
         password
         // role
       },
     ])
   }
       return (
         <>login page</>
         // <AuthProvider>
         // <Routes>
         //   {/* <Route
         //     element={<AuthLayout />}
         //     loader={() => defer({ userPromise: getUserData() })}
         //   > */}
         //   <Route path='/' element={<App />} />
         //   {/* </Route> */}
         //   <Route path='/1' element={<TestPage />} />
         //     {/* <Route element={<MainLayout />}>
         //      {/* <Route path='/' element={<App />} /> 
         //      <Route path='/login-temporary-page' element={<MainPage />}/>
         //      <Route path='/login-temporary-page/2fa' element={<TwoFAPage />} />
         //      <Route path='/login-temporary-page/login' element={<LoginPage />} /> 
         //     </Route>
         //     <Route path='/login-temporary-page/myaccount' element={<ProtectedLayout />}>
         //      <Route path='' element={<UserInfoPage />} />
         //      <Route path='setting' element={<SettingPage />} />
         //     </Route> */}
         // </Routes>
       //    <Route
       //   path="/secret"
       //   element={
       //     <ProtectedRoute auth2FA7={auth2FA6}>
       //       <Secret/>
       //     </ProtectedRoute>
       //     }
       // /> 
         // </AuthProvider>
         //<Routes>
         // {/* <Route element={<HomeLayout />} /> */}
         //  <Route path="/a" element={<HomePage />} />
         //  {/*  */}
         // {/* */}
         // {/* </Route>
         // <Route path="/myaccount" element={<ProtectedLayout />}> */}
         //     {/* <Route path="/" element={<UserInfoPage />} />
         //     <Route path="/setting" element={<SettingPage />} /> */}
         // {/* </Route> */}
         // {/* <Route
         //     path="/secret"
         //     element={
         //     <ProtectedRoute auth2FA7={auth2FA6}>
         //         <Secret/>
         //     </ProtectedRoute>
         //     }
         // /> */}
         // </Routes>
         // <div className='text-center p-1'>
         // <b>1-1 Login js</b><br/>
         // <div className='multi-all-output-form-lg flex flex-col'>
         //  {login?<>
         //  <div className='flex justify-between'><h4>main page</h4> <br/><IoIosLogOut onClick={(x)=>setLogin(!login)}/></div>
         //  {signup?<>
         //   <label className='primary-label' >email</label>
         //   <input className='primary-input' type='email' name='email' defaultValue={loginInput.email} onChange={onChange2Input1} />
         //   <label className='primary-label'>password</label>
         //   <input className='primary-input' type='text' name='password' defaultValue={loginInput.password} onChange={onChange2Input1} />
         //   {loginErr!=null?<p className='text-red-700'>{loginErr}</p>:''}
         //   <div className='flex justify-center'>
         //     <button className='primary-btn mt-1' >Update</button>
         //   </div>
         //   <u onClick={(x)=>setSignup(!signup)} className='cursor-default'>Cancel</u>
         //   </>:<><u onClick={(x)=>setSignup(!signup)} className='cursor-default'>Account information</u>
         //   </>}<u>Remove your account</u> {/* //modal shows to ask deleting account */}
 
         //  </>:<>{signup?<> create new account<br/>
         //   <label className='primary-label' >email</label>
         //   <input className='primary-input' type='email' name='email' defaultValue={loginInput.email} onChange={onChange2Input1} />
         //   <label className='primary-label'>password</label>
         //   <input className='primary-input' type='text' name='password' defaultValue={loginInput.password} onChange={onChange2Input1} />
         //   {loginErr!=null?<p className='text-red-700'>{loginErr}</p>:''}
         //   <div className='flex justify-center'><button className='primary-btn mt-1' onClick={onClick2Create}>Create</button></div>
         //   <div className='flex justify-center'><button className='text-xs' onClick={(x)=>setSignup(!signup)}>
         //   <u>Already have an account?</u>
         //   </button></div>
         //   </>:<>login<br/>
         //   <label className='primary-label' >email</label>
         //   <input className='primary-input' type='email' name='email' defaultValue={loginInput.email} onChange={onChange2Input1} />
         //   <label className='primary-label'>password</label>
         //   <input className='primary-input' type='text' name='password' defaultValue={loginInput.password} onChange={onChange2Input1} />
         //   {loginErr!=null?<p className='text-red-700'>{loginErr}</p>:''}
         //   <div className='flex justify-center'><button className='primary-btn mt-1' onClick={onClick2Login}>Login</button></div>
         //   <div className='flex justify-center'><button
         //     className='text-xs'
         //     onClick={(x)=>setSignup(!signup)}
         //   >
         //     <u>Create new account</u>
         //   </button></div></>}</>} 
         // </div>
         // <div className='multi-all-output-form-sm'>
         //   admin menu
         // {list1.map((x) => (
         //   <>
         //     {editMode ? (
         //      <div className='m-2'> 
         //      <div>
         //        <div className='multi-input-form-row1 mb-1'>
         //          <span>Email: </span>
         //          <input
         //            type='email'
         //            name='email'
         //            className='text-input-width'
         //            defaultValue={x.email}
         //            onChange={(y)=>onChange2Input2(y, x.id)}
         //          />
         //        </div>
         //        <div className='multi-input-form-row1 mb-1'>
         //          <span>Password: </span>
         //          <input
         //          className='text-input-width'
         //          name='password'
         //          defaultValue={x.password}
         //          onChange={(y)=>onChange2Input2(y, x.id)}
         //           />
         //        </div>
         //        {/* <div>
         //          <span>Role: </span>
         //          <select
         //             name='role'
         //            className='border-0 todo-select'
         //            defaultValue={x.role}
         //            onChange={(y)=>onChange2Input2(y, x.id)}
         //            placeholder='Please select'
         //          >
         //            <option value=''>Select</option>
         //            <option value='admin'>admin</option>
         //            <option value='user'>user</option>
         //          </select>
         //        </div> */}
         //      </div>
         //  </div>
         //     ) : (
         //       <div key={x.id}>
         //         <div className='text-right'>
         //           <button className='ml-1 mr-2' onClick={onClick2delete.bind(null, x.id)}><IoMdClose/></button>
         //         </div>
         //         <span>Email: {x.email}</span>
         //         <br />
         //         <span>Password: {x.password}</span>
         //         {/* <span>Role: {x.role}</span> */}
         //       </div>
         //     )}
         //   </>
         // ))}
         //   <div className='mb-2 flex justify-end'>{editMode ?     
         //     <form onSubmit={onSubmit2Update} ><button type='submit' className='mr-2'>
         //       Save
         //     </button><button type='button' onClick={e=>setEditMode(!editMode)}>Cancel</button>
         //   </form>:<><button onClick={onClick2Edit} className='edit-tool1'><MdEdit /></button><button className='primary-btn edit-tool2' onClick={onClick2Add}
         //   >Create new account</button></>}</div>
         // </div> 
         // </div>
       )
}
export function App1() {
     const [customerSecretKey4, setCustomerSecretKey4] = useState('')
     const [content4, setContent4] = useState('')
     const [path4, setPath4] = useState('')
     const content3 = (x) => {
          console.log('content changed')
          setContent4(x)
     } 
     const path3 = (x) => {
          console.log('path changed!')
          setPath4(x)
     } 
     const customerSecretKey3 = (x) => {setCustomerSecretKey4(x)}
     return (
          <>
          <div className='structure'>
          {/* <img  className='structure__main__bg' src={Fog}/>
          <img  className='structure__main__bg' src={Fog}/> */}
          <AuthProvider>
          <Routes>
          <Route element={<MainLayout />}>
          <Route path='/' element={<MainPage1 />}/>
          <Route path='/login' element={<LoginPage />} /> 
          <Route path='/membership-price-list' element={<AccountMembershipPage1 />} />
          <Route path='/test' element={<TestAbout/>} />
          <Route path='/react' element={<ReactPage1/>} /> 
          <Route path='/react/deploy' element={<ReactPage2/>} /> 
          <Route path='/react/basic' element={<ReactBasicPage />} />
          <Route path='/python' element={<PythonPage1/>} />    
          <Route path='/python/deploy' element={<PythonPage2/>} />    
          <Route path='/python/ai' element={<AIPage />} />
          <Route path='/python/basic' element={<BackendBasicPage />} />
          <Route path='/api' element={<APIPage/>} /> 
          <Route path='/api/nsdq' element={<NSDQPage/>} /> 
          <Route path='/api/nyse' element={<NYSEPage/>} /> 
          <Route path='/api/nsdq100' element={<NSDQ100Page/>} /> 
          <Route path='/api/nyse100' element={<NYSE100Page/>} /> 
          <Route path='/api/s&p500' element={<SandP500Page/>} /> 
          <Route path='/api/dowjones30' element={<DowJones30Page/>} /> 
          <Route path='/api/russel2000' element={<Russel2000Page/>} /> 
          <Route path='/api/oil' element={<OilPage/>} /> 
          <Route path='/api/gold' element={<GoldPage/>} /> 
          <Route path='/finance/asset_management' element={<AssetManagementPage/>} /> 
          <Route path='/finance/stock_notify' element={<StockNotifyPage/>} /> 
          <Route path='/finance/stock_portfolio' element={<StockPortfolioPage/>} /> 
          <Route path='/finance/stock_buysell' element={<StockBuySellPage/>} /> 
          <Route path='/reset-pwd' element={<ResetPwdPage />} /> 
          <Route path='/2fa' element={<TwoFAPage />} /> 
          <Route path='/signup' element={<SignUpPage />}/>
          <Route path='/verify-account' element={<VerifyAccountPage1 />}/>
          <Route path='/verify-account/:verificationcode' element={<VerifyAccountPage2 />}/>
          <Route path='/verify-email' element={<VerifyUpdatedEmailPage1 />}/>
          <Route path='/verify-email/:verificationcode' element={<VerifyUpdatedEmailPage2 />}/>
          <Route path='/404' element={<ErrorPage  />} />
          <Route path='/code-of-conduct' element={<CodeofConductPage />} />
          <Route path='/terms-and-conditions' element={<TermsandConditionAgreementsPage />} />
          <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
          <Route path='/contact-us' element={<ContactUsPage />} />
          <Route path='/:lv1' element={<RedirectLv1/>}/>
          <Route path='/:lv1/:lv2' element={<RedirectLv2/>}/>
          </Route>
          <Route path='' element={<ProtectedLayout content2={content3} path2={path3}/>}> 
          <Route path='/main' element={<MainPage2 />}/> //display after login
          <Route path='/react' element={<ReactPage1/>} /> 
          <Route path='/react/premium/encrypt' element={<TmpEncryptJS />} />
          <Route path='/react/shopping' element={<Shopping />} />
          <Route path='/react/shopping/pagination' element={<PaginationJS/>} />
          <Route path='/react/shopping/shopping-page' element={<ShoppintItemsJS/>} />
          <Route path='/react/shopping/payment' element={<PaymentJS/>} />
          <Route path='/python/notification' element={<Notification/>} />
          <Route path='/python/notification/email' element={<Page2 content5={content4} />} />
          <Route path='/python/notification/phonenumber' element={<Page content5={content4} />} /> 
          <Route path='/myaccount' element={<UserInfoPage />} /> 
          <Route path='/myaccount/payment' element={<PaymentPage customerSecretKey2={customerSecretKey3}/>}/>
          <Route path='/myaccount/account-membership' element={<AccountMembershipPage2 />} />
          <Route path='/myaccount/orders' element={<PurchasedHistoryPage />} />
          <Route path='/myaccount/purchased-code' element={<PurchasedCodePage />} />
          <Route path='/myaccount/after-purchase' element={<AfterPurchase />} />  
          <Route path='/myaccount/payment-success' element={<PaymentDonePage />} />
          <Route path='/:lv1' element={<RedirectLv1/>}/>
          <Route path='/:lv1/:lv2' element={<RedirectLv2/>}/>
          </Route>
          {/* <Route exact path='/reactnative' element={<ProtectedLayout_NextjsPageLayout content2={content3} path2={path3}/>}>
          <Route path='' element={<NextJsPage/>} />
          </Route> */}
          </Routes>
          </AuthProvider>
          <FooterNav/>
          </div>
          </>
     )
}
export default function App() {
  const ticket1 = localStorage.getItem('login different pages')
  return (
    <>
    {ticket1==null?<App1/>:<App2/>}
    </>
  )
}
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
     <BrowserRouter>
      <App /> 
     </BrowserRouter>
)


